import { Button } from 'antd';
import { AntModal } from '../../../components';
import { ChevronRightIcon } from '../../../components/assets';
import { useNavigate } from 'react-router-dom';

type RemoveITApplicationModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onRemove: () => void;
  applications: {
    name: string;
    workaroundUrl?: string;
  }[];
  extendActions?: JSX.Element | null;
  type?: string;
};

export const RemoveITApplicationModal = ({
  isOpen,
  onCancel,
  onRemove,
  applications,
  extendActions,
  type = 'Workarounds',
}: RemoveITApplicationModalProps) => {
  const navigate = useNavigate();

  return (
    <AntModal
      openModal={isOpen}
      onCancel={onCancel}
      title="Remove IT Application"
      footer={[
        <div key="footer" className="m-4 flex justify-between gap-4">
          <Button key="cancel" onClick={onCancel} shape="round">
            Cancel
          </Button>
          <Button
            key="remove"
            type="primary"
            danger
            onClick={onRemove}
            shape="round"
          >
            Remove Applications
          </Button>
        </div>,
      ]}
    >
      <div className="flex flex-col gap-3">
        <div className='flex flex-col gap-4 border-b border-gray-200 pb-2'>
         <p>You are about to remove IT Applications that have {type} set up.</p>
          <div className="flex justify-between">
            <p>IT Applications with {type}:</p>
            {extendActions && extendActions}
          </div>
        </div>
        <div className='flex flex-col gap-3'>
          {applications.map((app, index) => (
            <div
              key={index}
              className="flex items-center justify-between border-b border-gray-200 pb-2"
            >
              <span className="text-left font-semibold">{app.name}</span>
              {app.workaroundUrl && 
                <Button
                  type="link"
                  size="small"
                  onClick={() =>
                    app?.workaroundUrl ? navigate(app.workaroundUrl) : null
                  }
                  className="flex items-center p-0 h-auto"
                >
                  <div className="flex items-center gap-4">
                    View Workaround
                    {/* TODO: ChevronRightIcon hover effect doesn't trigger when hovering over "View Workaround" text */}
                    <ChevronRightIcon width={8} height={14} />
                  </div>
                </Button>
              }
            </div>
          ))}
        </div>

        <p className="font-semibold">
          This action will permanently delete the {type} associated to them.
          <br />
          Are you sure you want to do that?
        </p>
      </div>
    </AntModal>
  );
};
